import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HelperService, Option } from 'partnerhub';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import {
  OnboardingPartner,
  Partner,
  PartnerApi,
  PartnerContact,
  PartnerDependency,
  PartnerDetails,
  PartnerReferral,
  PartnerType,
  ReferralCode,
} from '../../../shared/models';

@Injectable({
  providedIn: 'root',
})
export class PartnerService {
  constructor(private readonly http: HttpClient, private readonly helperService: HelperService) {}

  public createDetail(partnerId: number, value: PartnerDetails): Observable<PartnerDetails> {
    const url = `/api/webapp-mep-maxis-admin/partners/details`;

    // TODO:
    console.warn('Not implemented');

    return;
  }

  public createPartner(obj): Observable<any> {

    console.log('OBJ:', obj);
    console.log('OBJ:', obj.partnerConfigurations.authType.id);

    const url = `/venus-api/partner/save`;

    const body = {
      id: 0,
      idVivo: obj.companyInformation.idVivo,
      name: obj.companyInformation.partnerName,
      description: obj.partnerConfigurations.partnerDescription,
      //cdate: "2021-05-07T00:00:00.002Z",
      country: obj.companyInformation.country ? obj.companyInformation.country : 'Brazil',
      cnpj: obj.companyInformation.cnpj,
      url: obj.companyInformation.webDomain,
      address: obj.companyInformation.address,
      postalCode: obj.companyInformation.postCode,
      email: obj.companyInformation.companyEmail,
      landLine: obj.companyInformation.landline,
      cellPhone: obj.companyInformation.phone,
      socialReason: obj.companyInformation.socialReason,
      companyType: obj.companyInformation.companyType,
      dateOfEstablishment: obj.companyInformation.dateOfEstablishment,
      state: obj.companyInformation.state,
      city: obj.companyInformation.city,
      corruptionTerm: obj.companyInformation.corruptionTerm,
      representativeName: obj.companyInformation.representativeName,
      representativeCPF: obj.companyInformation.representativeCPF,
      representativePosition: obj.companyInformation.representativePosition,
      representativeEmail: obj.companyInformation.representativeEmail,
      representativePhone: obj.companyInformation.representativePhone,
      representativeDigitalCertificate: obj.companyInformation.representativeDigitalCertificate.key === 'yes' ? true : false,
      representativeBankAgency: obj.companyInformation.representativeBankAgency,
      representativeBankAccount: obj.companyInformation.representativeBankAccount,
      representativePayeeName: obj.companyInformation.representativePayeeName,
      partnerConfiguration: obj.partnerConfigurations
      /*
      partnerConfiguration: {
        vendor: obj.partnerConfigurations.vendor,
        sicowebAllowed: obj.partnerConfigurations.sicowebAllowed,
        sicowebSendUserProfile: obj.partnerConfigurations.sicowebSendUserProfile,
        sicowebEncryptedMSISDN: obj.partnerConfigurations.sicowebEncryptedMSISDN,
        sicowebSendIMEI: obj.partnerConfigurations.sicowebSendIMEI,
        spRevId: obj.partnerConfigurations.spRevId,
        spRevPassword: obj.partnerConfigurations.spRevPassword,
        spRevIpAddress: obj.partnerConfigurations.spIpAddress,
        spPassword: obj.partnerConfigurations.spPassword,
        authType: obj.partnerConfigurations.authType.id
      }*/
    };
    
    body.partnerConfiguration.authType = obj.partnerConfigurations.authType.id;

    return this.http.post(url, body);
  }

  public deletePartner(id): Observable<any> {

    const url = `/venus-api/partner/delete/${id}`;

    return this.http.delete(url);
  }

  public updatePartner(id, data): Observable<any> {

    const url = `/venus-api/partner/save`;

    let body = {
      id,
      idVivo: "",
      name: "",
      description: "",
      cdate: "",
      country: "",
      cnpj: "",
      url: "",
      address: "",
      postalCode: "",
      email: "",
      landLine: "",
      cellPhone: ""
    };

    data.forEach(e => {
      body.name = e.fieldName == 'partnerName' ? e.value : body.name;
      body.description = e.fieldName == 'partnerDescription' ? e.value : body.description;
      body.country = e.fieldName == 'partnerCountry' ? e.value : body.country;
      body.cnpj = e.fieldName == 'partnerCnpj' ? e.value : body.cnpj;
      body.url = e.fieldName == 'partnerWebDomain' ? e.value : body.url;
      body.address = e.fieldName == 'partnerAddress' ? e.value : body.address;
      body.postalCode = e.fieldName == 'partnerPostalCode' ? e.value : body.postalCode;
      body.email = e.fieldName == 'email' ? e.value : body.email;
      body.landLine = e.fieldName == 'landline' ? e.value : body.landLine;
      body.cellPhone = e.fieldName == 'cellPhone' ? e.value : body.cellPhone;
    });

    console.log('BODY:', body);

    return this.http.post(url, body);
  }

  public createPartnerOld(
    partner: OnboardingPartner,
    referralCode = null,
    companyPresentation: { fileName: string; url: string },
    companyRegistration: { fileName: string; url: string },
    vatRegistration: { fileName: string; url: string },
    bankAccountProof: { fileName: string; url: string },
    shortCodeOwnership: { fileName: string; url: string },
    contract: { fileName: string; url: string },
    termsAndConditions: { fileName: string; url: string }
  ): Observable<any> {
    /**
     * Phone numbers are sent with a space separating the number
     * from the country indicative
     */

    const url = `/api/webapp-partnerhub-admin/partnership-requests`;

    const body = {
      name: partner.companyInformation.partnerName,
      country: partner.companyInformation.country,
      contactInformation: {
        email: partner.contactInformation.contactEmail,
        phone: `${(partner.contactInformation.mobilePhone as any).select} ${
          (partner.contactInformation.mobilePhone as any).input
        }`,
        name: partner.contactInformation.fullName,
        jobTitle: partner.contactInformation.jobTitle,
      },
      partnerDetails: [
        {
          key: 'ADDRESS',
          value: partner.companyInformation.address,
        },
        {
          key: 'COMPANY_WEBSITE',
          value: partner.companyInformation.webDomain,
        },
        {
          key: 'OFFICE_TELEPHONE_NUMBER',
          value: `${(partner.companyInformation.phone as any).select} ${
            (partner.companyInformation.phone as any).input
          }`,
        },
        {
          key: 'EMAIL',
          value: partner.companyInformation.companyEmail,
        },
        {
          key: 'VAT_NUMBER',
          value: partner.companyInformation.vatId,
        },
        {
          key: 'POSTAL_CODE',
          value: partner.companyInformation.postcode,
        },
      ],
      documents: [
        companyPresentation
          ? {
              fileName: companyPresentation.fileName,
              documentURL: companyPresentation.url,
              fileType: 'Company Presentation',
            }
          : undefined,
        companyRegistration
          ? {
              fileName: companyRegistration.fileName,
              documentURL: companyRegistration.url,
              fileType: 'Company Registration',
            }
          : undefined,
        bankAccountProof
          ? { fileName: bankAccountProof.fileName, documentURL: bankAccountProof.url, fileType: 'Bank Account Proof' }
          : undefined,
        contract ? { fileName: contract.fileName, documentURL: contract.url, fileType: 'Contract' } : undefined,
        vatRegistration
          ? {
              fileName: vatRegistration.fileName,
              documentURL: vatRegistration.url,
              fileType: 'Vat Registration',
            }
          : undefined,
        shortCodeOwnership
          ? {
              fileName: shortCodeOwnership.fileName,
              documentURL: shortCodeOwnership.url,
              fileType: 'Short Code Ownership',
            }
          : undefined,
        termsAndConditions
          ? {
              fileName: termsAndConditions.fileName,
              documentURL: termsAndConditions.url,
              fileType: 'Terms and Conditions',
            }
          : undefined,
      ],
      referralCode,
    };

    return this.http.post(url, body);
  }

  public createReferralCode(referralCode: ReferralCode): Observable<ReferralCode> {
    const url = `/api/webapp-partnerhub-admin/referralCodes`;

    return this.http.post<ReferralCode>(url, referralCode).pipe(pluck('responseData'));
  }

  public getPartnerApisByPartnerId(partnerId: number): Observable<PartnerApi[]> {
    const url = `/api/webapp-partnerhub-admin/partners/${partnerId}/apis`;

    return this.http.get<PartnerApi[]>(url).pipe(pluck('responseData'));
  }

  public getPartnerById(partnerId: number): Observable<Partner> {
    const url = `/api/webapp-partnerhub-admin/partners/${partnerId}`;

    return this.http.get<Partner>(url).pipe(pluck('responseData'));
  }

  // Partner Detail (Partner creation fields)
  public getPartnerByPartnerId(partnerId: number): Observable<Partner> {
    const url = `/api/webapp-mep-maxis-admin/partners/${partnerId}`;

    return this.http.get<Partner>(url).pipe(pluck('responseData'));
  }

  public getPartnerContactsByPartnerId(partnerId: number): Observable<PartnerContact[]> {
    const url = `/api/webapp-partnerhub-admin/partners/${partnerId}/contacts`;

    return this.http.get<PartnerContact[]>(url).pipe(pluck('responseData'));
  }

  public getPartnerDependenciesByPartnerId(partnerId: number): Observable<PartnerDependency[]> {
    const url = `/api/webapp-partnerhub-admin/partners/${partnerId}/dependencies`;

    return this.http.get<PartnerDependency[]>(url).pipe(pluck('responseData'));
  }

  // Partner Details (List of all the details)
  public getPartnerDetailsByPartnerId(partnerId: number): Observable<PartnerDetails[]> {
    const url = `/api/webapp-partnerhub-admin/partners/${partnerId}/details`;

    return this.http.get<PartnerDetails[]>(url).pipe(pluck('responseData'));
  }

  public getPartnerDetailsByPartnerIdObject(partnerId: number): Observable<PartnerDetails[]> {
    const url = `/api/webapp-partnerhub-admin/partners/${partnerId}`;

    return this.http.get<PartnerDetails[]>(url).pipe(pluck('responseData'));
  }

  public getPartnerDetailTypeNamesByTypeId(typeId: number): Observable<Option[]> {
    const url = `/api/webapp-mep-maxis-admin/partners/details/types/${typeId}/names`;

    return this.http.get<Option[]>(url).pipe(pluck('responseData'));
  }

  public getPartnerDetailTypes(): Observable<Option[]> {
    const url = `/api/webapp-mep-maxis-admin/partners/details/types`;

    return this.http.get<Option[]>(url).pipe(pluck('responseData'));
  }

  public getPartners(): Observable<Partner[]> {
    return this.getPartnersPaginated(0, 10000).pipe(pluck('responseData'));
  }

  public getPartnersByStatusId(
    statusId: number,
    offset: number = null,
    pageIncrement: number = null
  ): Observable<{ responseData: Partner[]; totalResultSize: number }> {
    const url = `/api/webapp-partnerhub-admin/partners/status/${statusId}`;

    const queryParameters = this.helperService.setHttpQueryParameters([
      { name: 'offset', value: offset },
      { name: 'limit', value: pageIncrement },
    ]);

    return this.http.get<{ responseData: Partner[]; totalResultSize: number }>(url, { params: queryParameters });
  }

  public getPartnersPaginated(
    offset: number = null,
    pageIncrement: number = null
  ): Observable<{ responseData: Partner[]; totalResultSize: number }> {
    const url = `/api/webapp-partnerhub-admin/partners`;

    const queryParameters = this.helperService.setHttpQueryParameters([
      { name: 'offset', value: offset },
      { name: 'limit', value: pageIncrement },
    ]);

    return this.http.get<{ responseData: Partner[]; totalResultSize: number }>(url, { params: queryParameters });
  }

  public getPartnerTypes(): Observable<PartnerType[]> {
    const url = `/api/webapp-partnerhub-admin/partners/types`;

    return this.http.get<PartnerType[]>(url).pipe(pluck('responseData'));
  }

  public validateReferralCode(referralCode: string): Observable<PartnerReferral> {
    const url = `/api/webapp-partnerhub-admin/referralCodes/validate/${referralCode}`;

    return this.http.get<PartnerReferral>(url).pipe(pluck('responseData'));
  }
}
